import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private httpClient: HttpClient) { }

  firebaseEmailFn: string = "https://us-central1-scgm-po.cloudfunctions.net/sendMail?dest=";

  sendEmail(emailId){
    return this.httpClient.post(this.firebaseEmailFn + emailId, {});
  }
}
